import React, { useState } from "react";
import { twMerge } from "tailwind-merge";

import { Icon } from "@ui/icons/icon";
import { ICON_COLLECTION } from "@ui/icons/icon-list";
import { Token } from "@/pages/create-fund/components/select-tokens/select-tokens";

interface Props {
  token: Token;
  handleSelect: (token: Token) => void;
  style: React.CSSProperties;
}

export const TokensTableRow: React.FC<Props> = ({
  token,
  handleSelect,
  style,
}) => {
  const [showFullId, setShowFullId] = useState(false);
  const truncatedId = `${token.policy_id.slice(0, 3)}...${token.policy_id.slice(
    -6,
  )}`;
  const priceLovelace = token.token_price_lovelace;
  const isPriceAvailable = typeof priceLovelace === "number";
  const priceClassName = "text-xs text-gray-500 dark:text-gray-400";
  const unavailableClassName = "text-red-500 dark:text-red-400";
  const priceText = isPriceAvailable
    ? (priceLovelace / 1_000_000).toLocaleString("en", {
        maximumFractionDigits: 6,
      })
    : null;

  const imageLink = token.token_image?.startsWith("ipfs")
    ? token.token_image.replace("ipfs://", "https://ipfs.io/ipfs/")
    : token.token_image;

  const displayName = token.token_symbol || token.token_name || "";
  const hasImage = !!imageLink;
  const initial = displayName.charAt(0).toUpperCase();

  const onMouseOver = () => setShowFullId(true);
  const onMouseOut = () => setShowFullId(false);

  return (
    <button
      type="button"
      style={style}
      onClick={() => handleSelect(token)}
      className="flex items-center justify-between w-full py-3 border-b border-gray-100 dark:border-gray-800"
    >
      <div className="flex items-center gap-2">
        {hasImage ? (
          <img src={imageLink} alt="" className="h-12" />
        ) : (
          <div className="h-12 w-12 rounded-full bg-violet-200 dark:bg-gray-700 flex items-center justify-center text-violet-600 dark:text-violet-300 font-semibold text-lg">
            {initial || "?"}
          </div>
        )}
        <div className="flex flex-col items-start text-left">
          <h6 className="font-sf-pro text-lg md:text-xl text-gray-800 dark:text-white font-semibold text-left">
            {displayName}
          </h6>
          {isPriceAvailable ? (
            <span className={priceClassName}>Price: {priceText} ADA</span>
          ) : (
            <span className={priceClassName}>
              Price: <span className={unavailableClassName}>unavailable</span>
            </span>
          )}
        </div>
        {/*{token.verified ? (*/}
        {/*  <Icon icon={ICON_COLLECTION.circleCheck} iconColor="#7C3AED" />*/}
        {/*) : null}*/}
      </div>
      <span
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        className={twMerge(
          "font-sf-pro text-sm md:text-base text-gray-500",
          showFullId && "bg-white dark:bg-gray-900 z-10",
        )}
      >
        {showFullId ? token.policy_id : truncatedId}
      </span>
    </button>
  );
};
